// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8573aae0","160":"ef743896","208":"3ea8d9c0","293":"4010a4f7","516":"c673f50f","519":"524711a4","840":"83763cc6","917":"76c86db9","946":"89d83c36"}[chunkId] + ".chunk.js";
};